import {
  DinoScript
} from "./chunk-FT4HFPN2.mjs";
import {
  Resources
} from "./chunk-5SZML4Z5.mjs";

// src/Dino.tsx
import React from "react";
var DinoGame = React.forwardRef(function DinoGame2({ instructions, hideInstructions }, ref) {
  const startDiv = React.useRef(null);
  const endDiv = React.useRef(null);
  React.useEffect(() => {
    if (!(startDiv.current && endDiv.current))
      return;
    if (!document.querySelector(`#${dinoScriptId}`)) {
      const dinoScriptContainer = document.createElement("script");
      dinoScriptContainer.id = dinoScriptId;
      dinoScriptContainer.appendChild(document.createTextNode(DinoScript));
      startDiv.current.appendChild(dinoScriptContainer);
    }
    if (!document.querySelector(`#${runnerScriptId}`)) {
      const runnerScriptContainer = document.createElement("script");
      runnerScriptContainer.id = runnerScriptId;
      runnerScriptContainer.appendChild(document.createTextNode(`new Runner('.interstitial-wrapper');`));
      endDiv.current.appendChild(runnerScriptContainer);
    }
  }, []);
  return /* @__PURE__ */ React.createElement("div", {
    ref
  }, /* @__PURE__ */ React.createElement("div", {
    ref: startDiv,
    className: "react-chrome-dino"
  }, /* @__PURE__ */ React.createElement("div", {
    className: "interstitial-wrapper",
    id: "main-frame-error"
  }, /* @__PURE__ */ React.createElement(Resources, null), /* @__PURE__ */ React.createElement("div", {
    ref: endDiv
  })), !hideInstructions && /* @__PURE__ */ React.createElement("div", {
    className: "interstitial-wrapper instructions"
  }, instructions || /* @__PURE__ */ React.createElement("p", null, "Press the ", /* @__PURE__ */ React.createElement("span", {
    className: "kbd"
  }, "spacebar"), " to start the game and to jump."))));
});
var dinoScriptId = "dino-script-container";
var runnerScriptId = "runner-script-container";
var Dino_default = DinoGame;

export {
  Dino_default
};
